import { Col, Container, Row, Visible } from "react-grid-system"
import { CartStructure, Product } from "../../../interfaces/SaleorTypes"
import Card from "../../../atoms/Card"
import styled from "styled-components"
import { HorizontalSpacer, Spacer } from "../../../atoms/spacers"
import H1 from "../../../atoms/typography/H1"
import H2 from "../../../atoms/typography/H2"
import Body from "../../../atoms/typography/Body"
import H3 from "../../../atoms/typography/H3"
import AttributeIcon from "../../../store/AttributeIcon"
//@ts-ignore
import ReddotSVG from "../../../atoms/icons/images/reddot.svg"
import { getProductSpecificsForStoreCards } from "../../../../utils/formatters"
import KuImageSlider from "../../../molecules/store/KuImageSliders.tsx/KuImageSlider"
import { getKuImage } from "../../../molecules/store/KuImageSliders.tsx/kuSlideUrls"
import { getSecureImage } from "../../../molecules/store/KuImageSliders.tsx/secureSlideUrls"
import { theme } from "../../../theme"
import TextButton from "../../../atoms/buttons/TextButton"
import { ArrowRight } from "../../../atoms/icons/ArrowRight"
import { getFormattedPrice } from "../../../../utils/cart-helpers"
import { Link } from "react-router-dom"

interface Props {
  product: Product
  addToCart: (products: CartStructure[]) => void
}

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const ProductSectionContainer = styled.div`
  padding: 32px 40px;
`

const BottomActionBar = styled.div``

const GreyCol = styled(Col)`
  background-color: ${(props) => props.theme.colors.dark};
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
const GradientCol = styled(Col)<{ gradient: string }>`
  background: ${(props) => props.gradient};
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

interface PooductInfoSectionProps {
  icon: React.ReactNode
  title: string
  text: string
}

const ProductInfoSection: React.FC<PooductInfoSectionProps> = ({ icon, title, text }) => {
  return (
    <div>
      <Row nogutter align="center">
        {icon} <Spacer spacing={0.5} />
        <H3>{title}</H3>
      </Row>
      <HorizontalSpacer spacing={0.5} />
      <Body>{text}</Body>
    </div>
  )
}

const ProductCard: React.FC<Props> = ({ product, addToCart }) => {
  const productInfo = getProductSpecificsForStoreCards(product)
  const productImage = product?.media[0]?.url
  const productName = product?.name

  const ImageComponet = productName.includes("Ku") ? (
    <KuImageSlider numOfImgs={119} folderDir="https://i.imgur.com/" ext=".jpg" baseNameFunction={getKuImage} />
  ) : productName.includes("Secure") ? (
    <KuImageSlider numOfImgs={119} folderDir="https://i.imgur.com/" ext=".jpg" baseNameFunction={getSecureImage} />
  ) : (
    <ProductImage src={productImage} alt="Image of Satcube Satellite product" />
  )

  const gradientColor = productName.includes("Ku")
    ? theme.gradients.blue
    : productName.includes("Secure")
      ? theme.gradients.green
      : theme.gradients.yellow

  const productPageLink = productName.includes("Ku") ? "/products/ku" : "/products/secure"
  const customizePageLink = productName.includes("Ku") ? "/store/customize/ku" : "/store/customize/secure"

  return (
    <div>
      <Container>
        <Card noPadding>
          <ProductSectionContainer>
            <Row>
              <Col lg={6}>{ImageComponet}</Col>
              <Col lg={6}>
                <Visible xs sm md>
                  <HorizontalSpacer spacing={35} />
                </Visible>
                <H1>{productName}</H1>
                <H2>{productInfo.tagline}</H2>
                <HorizontalSpacer spacing={1.5} />
                <Body>{productInfo.desc}</Body>

                <HorizontalSpacer spacing={1.5} />

                <div>
                  <Row>
                    <Col lg={6}>
                      <ProductInfoSection
                        icon={<AttributeIcon icon={productInfo.statOneIcon} />}
                        title={productInfo.statOneText}
                        text={productInfo.statOneSubtext}
                      />
                    </Col>
                    <Col lg={6}>
                      <ProductInfoSection
                        icon={<AttributeIcon icon={productInfo.statTwoIcon} />}
                        title={productInfo.statTwoText}
                        text={productInfo.statTwoSubtext}
                      />
                    </Col>
                  </Row>

                  <HorizontalSpacer spacing={1.5} />
                  <Row>
                    <Col lg={6}>
                      <ProductInfoSection
                        icon={<AttributeIcon icon={productInfo.statThreeIcon} />}
                        title={productInfo.statThreeText}
                        text={productInfo.statThreeSubtext}
                      />
                    </Col>
                    <Col lg={6}>
                      <ProductInfoSection
                        icon={<AttributeIcon icon={productInfo.statFourIcon} />}
                        title={productInfo.statFourText}
                        text={productInfo.statFourSubtext}
                      />
                    </Col>
                  </Row>
                </div>

                <HorizontalSpacer spacing={1.5} />

                <div>
                  <Row justify="between" align="end" nogutter>
                    <ReddotSVG />
                    <H3>
                      Price:{" "}
                      {getFormattedPrice(
                        product.variants[0].pricing.price.gross.amount,
                        product.variants[0].pricing.price.currency,
                      )}
                    </H3>
                  </Row>
                </div>
              </Col>
            </Row>
          </ProductSectionContainer>

          <BottomActionBar>
            <Row>
              <GreyCol lg={6}>
                <Link to={productPageLink}>
                  <TextButton color="white" title="Learn more" />
                </Link>
              </GreyCol>
              <GradientCol gradient={gradientColor} lg={6}>
                <Link to={customizePageLink}>
                  <TextButton color="white" title="Customize and order" icon={<ArrowRight color="white" />} />
                </Link>
              </GradientCol>
            </Row>
          </BottomActionBar>
        </Card>
      </Container>
      <HorizontalSpacer spacing={3} />
    </div>
  )
}

export default ProductCard
